<div class="d-flex align-items-center flex-wrap marginLeftDateAndTime theme-interface">
  <div class="d-flex flex-wrap align-items-center my-n3">
    <mat-form-field style="width: 20px;" class="hide-element">
      <input [min]="adminView ? null : minDate" class="hide-element" hidden matInput [matDatepicker]="picker"
        (dateChange)="onDateChange($event)">
      <mat-datepicker #picker [startAt]="displayedDate"></mat-datepicker>
    </mat-form-field>
    <mat-datepicker-toggle matSuffix [for]="picker" class="theme-color-date-icon "></mat-datepicker-toggle>
  </div>
  <div class="d-flex align-items-center">
    <div class="d-flex dateSelector">
      <div class="d-flex px-2 px-sm-1 arrow down m-auto" (click)="decrementDate()">
        <i class="fas fa-chevron-left theme-color-header"></i>
      </div>
      <div style="width: 95px;">
        <div class="d-flex py-2 justify-content-center px-0 space-nowrap">
          {{ date | date:'EEE dd MMM' }}
        </div>

      </div>
      <div class="d-flex px-2 px-sm-1 arrow up m-auto" (click)="incrementDate()"><i
          class="fas fa-chevron-right theme-color-header"></i>
      </div>
    </div>

  </div>
</div>